import { useLocale } from "../hooks/useLocale";
import { msg } from "../locales/translate";
import { ErrorUtils } from "@net/error/ErrorUtils";
import { Box } from "@ui/box/Box";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { TypoCaption, TypoError, TypoMedium } from "@ui/text/Typo";
import { useEffect } from "react";
import { GD } from "../GD";
import { IProject } from "../services/Projects";

export const ProjectEditorView = () => {
	useLocale();
	const projectEditorRequest = GD.S_PROJECT_EDITOR.use([]);
	const [project, request, reset, busy] = GD.REQ_PROJECT_BY_ID.useRequest();
	const [saveResult, save, resetSaveResult, saveBusy] =
		GD.REQ_PROJECT_SAVE.useRequest();

	// determine project to open
	useEffect(() => {
		if (projectEditorRequest) {
			if (projectEditorRequest.projectID < 1) {
				reset({
					id: -1,
					name: "",
					roles: [],
				});
			} else {
				request({ projectID: projectEditorRequest.projectID });
			}
		} else {
			reset(null);
		}

		return () => {};
	}, [projectEditorRequest]);

	if (projectEditorRequest === null) return null;

	const formSubmit = (data: IProject) => {
		resetSaveResult(null);
		save({ ...data });
	};

	return (
		<Panel
			decorator="absolute"
			busy={busy || saveBusy}
			sx={{
				minWidth: "350px",
			}}
			label={msg("projectEditor")}>
			<Box>
				<TypoCaption>
					{project && project?.id > 0
						? msg("editExistingProject") + project.id
						: msg("createNewProject")}
				</TypoCaption>
			</Box>

			{saveResult && ErrorUtils.isError(saveResult) && (
				<>
					<Spacer size="20px" />
					<Box
						sx={{
							border: "1px dashed red",
							padding: "10px",
							borderRadius: "6px",
							backgroundColor: "rgba(255,0,0,0.1)",
						}}>
						<TypoError>{(saveResult as IError).message}</TypoError>
						{saveResult && (saveResult as IError).details && (
							<TypoMedium block>
								{(saveResult as IError).details}
							</TypoMedium>
						)}
					</Box>
				</>
			)}

			<Spacer size="20px" />

			<Form
				data={project}
				onSubmit={formSubmit}
				onCancel={() => {
					resetSaveResult(null);
					GD.S_PROJECT_EDITOR.invoke(null);
				}}
				sx={{
					minWidth: "300px",
				}}
			/>
		</Panel>
	);
};
